import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PoloHelper } from '@app/_shared/_helpers/polo.helper';
import { ForumEvenementService } from '@app/_shared/_services/forum/evenement.service';
import { ForumInscriptionService } from '@app/_shared/_services/forum/inscription.service';
import { ForumOffreService } from '@app/_shared/_services/forum/offre.service';
import { environment } from '@environments/environment';
import * as _ from 'underscore'
declare var INSPIRO

@Component({
  selector: 'app-cllajoffres',
  templateUrl: './cllajoffres.component.html',
  styleUrls: ['./cllajoffres.component.scss']
})
export class CllajoffresComponent implements OnInit {

  @Output() onClose:EventEmitter<any> = new EventEmitter<any>();
  offres= []

  uploadedFilesUrl: string = environment.uploadedFilesUrl;
  currentItem;
  offresVisible:boolean = true;
  hasFirstClick:boolean = false;
  constructor(
    public inscriptionService:ForumInscriptionService,
    private _sanitizer: DomSanitizer,
    private evenementService: ForumEvenementService,private offresService:ForumOffreService, private poloHelper:PoloHelper) { }

  ngOnInit(): void {
    if(typeof this.inscriptionService.form?.offres == "undefined")
    this.inscriptionService.form.offres = {}
    if(typeof this.inscriptionService.form?.offres?.selectedItems == "undefined")
    this.inscriptionService.form.offres.selectedItems = []
    this.refreshOffres()
  }
  refreshSliders(){
    setTimeout(()=>{
      INSPIRO.slider.carousel();
      setTimeout(()=>{

        INSPIRO.slider.inspiroSlider();
        setTimeout(()=>{
          INSPIRO.elements.magnificPopup();
        },1000)
      },400)
    },200)
  }

  refreshOffres(){
    let filter = {};

    // filter
    this.offresService.getItems(filter,[["idImagePrincipale","desc"]],1,1000).subscribe(res=>{
      this.offres = res.items.map(it=>{
        if(!it.imagePrincipale)
        it.imagePrincipale = {id:0,title:""}
        if(it.medias.length)
        it.medias = _.sortBy(it.medias, m => m.title);
        else it.medias = [{id:0,title:""}]
        return it});
      this.setCurrentItem(this.offres[0])
    })
  }

  setCurrentItem(item){
    this.currentItem = null
    setTimeout(() => {
    this.currentItem = item
    setTimeout(() => {
    this.refreshSliders()
    }, 400);
    }, 200);
  }
  getAsBackground(image) {
    let url = this.uploadedFilesUrl + image;

    if(image == "0/")
    url = "assets/images/nophoto.png"
    console.log('image',url)
      return this._sanitizer.bypassSecurityTrustStyle(
        `url('${url}')`
      );
  }
  toggleOffres(){
    this.offresVisible = !this.offresVisible
  }
  isSelectedItem(item){
    for (let index = 0; index < this.inscriptionService.form.offres.selectedItems.length; index++) {
      const element = this.inscriptionService.form.offres.selectedItems[index];
      if(element && element?.id == item.id)
        return true;
    }
    return false;
  }
  selectItem(item){
    if(item)
    this.inscriptionService.form.offres.selectedItems.push(_.clone(item));
    this.checkCanNextStep()
  }
  unselectItem(item){
    for (let index = 0; index < this.inscriptionService.form.offres.selectedItems.length; index++) {
      const element = this.inscriptionService.form.offres.selectedItems[index];
      if(element && element?.id == item.id){
         this.inscriptionService.form.offres.selectedItems.splice(index, 1);
        break;
      }
    }
    this.checkCanNextStep()
  }

  checkCanNextStep(){

  }

  close(){
    this.onClose.emit()
}

}
